module.exports = __webpack_public_path__ + "img/ingredienten-spicy-tomatenpastasaus.b82b5cfe.jpeg";